export enum BoxUdiEnum {
    UDI1 = '03770034521006',
}
